[
  {
    "id": "mlbook",
    "path": "M 0 0 L 466 0 L 466 661 L 0 661 L 0 0",
    "viewbox": "0 0 466 661"
  },
  {
    "id": "yunomi",
    "path": "M 43 648 L 14 541 L 0 54 L 0 53 L 15 42 L 23 38 L 53 24 L 64 19 L 72 17 L 148 4 L 244 4 L 258 6 L 311 14 L 317 15 L 327 17 L 332 19 L 348 26 L 370 36 L 378 40 L 382 44 L 383 49 L 386 66 L 387 72 L 389 86 L 392 119 L 394 211 L 394 254 L 392 533 L 387 543 L 359 590 L 357 593 L 351 600 L 339 612 L 335 615 L 329 619 L 324 622 L 317 626 L 308 630 L 293 635 L 275 640 L 266 642 L 256 644 L 250 645 L 236 647 L 223 648 L 43 648",
    "viewbox": "0 0 394 644"
  },
  {
    "id": "fujirock",
    "path": "M 0 308 L 113 22 L 117 14 L 130 1 L 132 0 L 138 0 L 203 64 L 208 69 L 323 298 L 325 311 L 327 328 L 327 334 L 326 337 L 325 339 L 191 591 L 188 594 L 187 594 L 184 591 L 0 309 L 0 308",
    "viewbox": "0 0 327 594"
  },
  {
    "id": "spoon",
    "path": "M 0 167 L 0 76 L 12 36 L 16 28 L 36 8 L 52 0 L 100 0 L 112 10 L 123 21 L 129 29 L 136 42 L 137 44 L 148 68 L 153 100 L 153 163 L 133 805 L 129 809 L 123 812 L 120 813 L 113 815 L 106 816 L 53 816 L 43 814 L 36 811 L 31 808 L 30 807 L 29 805 L 0 167",
    "viewbox": "0 0 153 816"
  },
  {
    "id": "emoji-scavenger-hunt",
    "path": "M 0 0 L 575 0 L 575 323 L 0 323 L 0 0",
    "viewbox": "0 0 575 323"
  },
  {
    "id": "butsuri",
    "path": "M 286 1 L 644 280 L 644 415 L 614 415 L 97 297 L 95 296 L 81 283 L 66 269 L 46 249 L 30 232 L 22 223 L 1 194 L 0 191 L 0 178 L 3 175 L 49 145 L 132 91 L 259 9 L 272 1 L 274 0 L 284 0 L 286 1",
    "viewbox": "0 0 644 415"
  },
  {
    "id": "budou",
    "path": "M 0 344 L 0 301 L 81 3 L 82 0 L 321 80 L 442 300 L 442 345 L 363 464 L 283 584 L 243 624 L 200 624 L 160 584 L 0 344",
    "viewbox": "0 0 442 624"
  },
  {
    "id": "guideline",
    "path": "M 561 97 L 799 406 L 799 449 L 0 449 L 0 415 L 1 414 L 252 187 L 436 39 L 438 38 L 439 38 L 452 39 L 458 40 L 557 94 L 560 96 L 561 97",
    "viewbox": "0 0 799 411"
  },
  {
    "id": "shibuya-stream",
    "path": "M 0 601 L 0 297 L 47 100 L 50 97 L 197 0 L 251 0 L 548 47 L 551 50 L 599 347 L 599 551 L 499 601 L 301 699 L 247 699 L 0 601",
    "viewbox": "0 0 599 699"
  }
]
